<template>
  <div class="nuevo-precio-container">
    <section class="pedido-steps">
      <div class="row">
          <div class="col-12">
            <div class="return d-block d-sm-none">
              <router-link to="/pricing-home">
                <img :src="require('../../../assets/img/backspace.svg')" class="mb-5">
              </router-link>
            </div>
            <div class="section-title">
              <h5 class="pull-left" title="Ajuda sobre o histórico de preços">
                {{ $t('pricing.nprecio') }}
              </h5>
              <router-link to="/pricing-home">
                <img class="d-none d-sm-block" :src="require('../../../assets/img/backspace.svg')">
              </router-link>
            </div>
          </div>
      </div>

    <div class="card">
      <h2 class="subtitulo">{{ $t('pricing.nuevo_precio.help') }}</h2>
      <p>{{ $t('pricing.nuevo_precio.helpText') }}</p>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label for="fechaInicio">{{ $t('pricing.nuevo_precio.startDate') }}</label>
        <input
          type="date"
          id="fechaInicio"
          v-model="fechaInicio"
          :min="fechaMinima"
          ref="inputFechaInicio"
          @focus="abrirCalendario"
        >
      </div>
      <div class="form-group">
        <label for="fechaFin">{{ $t('pricing.nuevo_precio.endDate') }}</label>
        <input
          type="date"
          id="fechaFin"
          v-model="fechaFin"
          :min="fechaInicio"
          :disabled="!fechaInicio"
          ref="inputFechaFin"
          @focus="abrirCalendarioFin"
        >
      </div>
    </div>

    <div class="form-group">
      <label for="distribuidor">{{ $t('pricing.nuevo_precio.distribuidor') }}</label>
      <multiselect
        id="distribuidor"
        input-id="distribuidor"
        v-model="distribuidor"
        :options="distribuidores"
        :searchable="true"
        :close-on-select="true"
        :clear-on-select="false"
        :preserve-search="true"
        :placeholder="$t('pricing.nuevo_precio.selectOption')"
        :custom-label="customLabelDistribuidores"
        :custom-filter="customFilterDistribuidores"
        label="name"
        track-by="ean"
        :disabled="distribuidores.length === 0"
        :allow-empty="true"
      >
        <template #option="{ option }">
          {{ option.ean }} - {{ option.name }}
        </template>
        <template #singleLabel="{ option }">
          {{ option.ean }} - {{ option.name }}
        </template>
      </multiselect>
    </div>

    <div class="form-group precio-mode-group">
      <label>{{ $t('pricing.nuevo_precio.precioMode') }}</label>
      <div class="precio-mode-toggle">
        <label>
          <input type="radio" value="lb" v-model="precioMode">
          {{ $t('pricing.nuevo_precio.precioUsdLb') }}
        </label>
        <label>
          <input type="radio" value="caja" v-model="precioMode">
          {{ $t('pricing.nuevo_precio.precioUsdCajaLabel') }}
        </label>
      </div>
    </div>

      <div
          class="producto-card"
          v-for="(linea, index) in lineasProducto"
          :key="linea.id"
      >
        <div class="producto-card-header">
          <span>{{ $t('pricing.nuevo_precio.selectProduct') }} {{ index + 1 }}</span>
        </div>

        <div class="producto-form">
          <!-- Planta por línea -->
          <div class="form-group planta-select">
            <label v-if="index === 0" :for="'planta-' + linea.id">{{ $t('pricing.nuevo_precio.selectPlant') }}</label>
            <div v-show="isLoadingPlants">
              <div class="spinner"></div>
            </div>
            <multiselect
                :id="'planta-' + linea.id"
                :input-id="'planta-' + linea.id"
                v-show="!isLoadingPlants"
                v-model="linea.planta"
                :options="plants"
                :searchable="true"
                :close-on-select="true"
                :allow-empty="true"
                :placeholder="$t('pricing.nuevo_precio.selectOption')"
                :custom-label="customLabelPlanta"
                track-by="DC"
                :disabled="plants.length === 0"
                @select="onSelectPlanta(linea, $event)"
                @remove="onRemovePlanta(linea)"
            >
              <template #option="{ option }">
                {{ option.DC }} - {{ option.plant_name }}
              </template>
              <template #singleLabel="{ option }">
                {{ option.DC }} - {{ option.plant_name }}
              </template>
            </multiselect>
          </div>

          <!-- SKU -->
          <div class="form-group producto-select">
            <label v-if="index === 0" :for="'producto-' + linea.id">{{ $t('pricing.nuevo_precio.selectProduct') }}</label>
            <div v-show="linea.isLoadingSkus">
              <div class="spinner"></div>
            </div>
            <multiselect
                :id="'producto-' + linea.id"
                :input-id="'producto-' + linea.id"
                v-show="!linea.isLoadingSkus"
                v-model="linea.sku"
                :multiple="false"
                :options="linea.skus"
                :searchable="true"
                :close-on-select="true"
                :clear-on-select="false"
                :preserve-search="true"
                :placeholder="$t('pricing.nuevo_precio.selectOption')"
                :custom-label="customLabelSkus"
                :filter-by="filterBy"
                label="sku"
                track-by="id"
                :disabled="linea.skus.length === 0"
            >
              <template #option="{ option }">
                {{ option.id }} - {{ option.sku }}
              </template>
              <template #singleLabel="{ option }">
                {{ option.id }} - {{ option.sku }}
              </template>
            </multiselect>
          </div>

          <!-- Precio -->
          <div class="form-group precio-input">
            <label v-if="index === 0" :for="'precio-' + linea.id">
              {{ precioMode === 'lb' ? $t('pricing.nuevo_precio.precioUsdLb') : $t('pricing.nuevo_precio.precioUsdCajaLabel') }}
            </label>
            <input :id="'precio-' + linea.id" type="number" min="0" step="0.01" v-model.number="linea.precioUsuario">
          </div>

          <!-- Volumen -->
          <div class="form-group volumen-input">
            <label v-if="index === 0" :for="'volumen-' + linea.id">{{ $t('pricing.nuevo_precio.volumenUsdLb') }}</label>
            <div class="volumen-acciones">
              <input
                  :id="'volumen-' + linea.id"
                  class="volumen-field"
                  type="number"
                  min="0"
                  step="0.01"
                  v-model.number="linea.volumen"
              >
              <button
                  type="button"
                  class="btn-icon"
                  @click="agregarLinea"
                  v-if="index === lineasProducto.length - 1"
              >
                +
              </button>
              <button
                  type="button"
                  class="btn-icon btn-delete"
                  @click="eliminarLinea(index)"
                  v-if="lineasProducto.length > 1"
              >
                -
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
          v-if="showLineasError"
          class="alert alert-danger lineas-alert"
          role="alert"
      >
        {{ lineasErrorMessage }}
      </div>

      <div
          v-if="showAgregarError"
          class="alert alert-danger lineas-alert"
          role="alert"
      >
        {{ agregarErrorMessage }}
      </div>

    <div class="acciones">
      <button class="btn verde" :disabled="!puedeAgregar" @click="addToCart">
        <img src="@/assets/img/addprice.png" alt="Lupa" style="width: 16px; height: 16px; margin-right: 5px;" />
        {{ $t('pricing.nuevo_precio.agregar') }}
      </button>
      <button class="btn celeste" :disabled="!puedeSimular" @click="simular">
        <img src="@/assets/img/lupa.png" alt="Add" style="width: 16px; height: 16px; margin-right: 5px;" />
        {{ $t('pricing.nuevo_precio.simulador') }}
      </button>
      <small v-if="lineasProducto.length > 1" class="text-muted">
        {{ $t('pricing.nuevo_precio.condicion_agregar') }}
      </small>
    </div>

    <!-- Cards de condiciones comerciales: se muestran solo cuando hay productos agregados -->
    <template v-if="productosAgregados.length > 0">
      <div class="card">
        <h2>{{ $t('pricing.nuevo_precio.flete') }}</h2>
        <div class="form-row">
          <div class="form-group">
            <label>{{ $t('pricing.nuevo_precio.porLb') }}</label>
            <input type="number" :value="currentPlantData && currentPlantData.fleteLb" disabled>
          </div>
          <div class="form-group">
            <label>{{ $t('pricing.nuevo_precio.porKg') }}</label>
            <input type="number" :value="currentPlantData && currentPlantData.fleteKg" disabled>
          </div>
          <div class="form-group">
            <label>{{ $t('pricing.nuevo_precio.primary') }}</label>
            <input type="text" :value="currentPlantData && currentPlantData.carrier" disabled>
          </div>
        </div>
      </div>

      <div class="card">
        <h2>{{ $t('pricing.nuevo_precio.incoterm') }} / {{ $t('pricing.nuevo_precio.invoice') }} / {{ $t('pricing.nuevo_precio.delivery') }}</h2>
        <div class="form-row">
          <div class="form-group">
            <label>{{ $t('pricing.nuevo_precio.incoterm') }}</label>
            <input type="text" :value="currentPlantData && currentPlantData.incoterm" disabled>
          </div>
          <div class="form-group">
            <label>{{ $t('pricing.nuevo_precio.invoice') }}</label>
            <input type="text" :value="currentPlantData && currentPlantData.invoiceMode" disabled>
          </div>
          <div class="form-group">
            <label>{{ $t('pricing.nuevo_precio.delivery') }}</label>
            <input type="text" :value="currentPlantData && currentPlantData.delivery" disabled>
          </div>
        </div>
      </div>

      <div v-if="currentPlantData && currentPlantData.invoiceMode === 'EXW + Freight'" class="card" id="panel_exw_flete">
        <h2>EXW + Flete Price</h2>
        <div class="form-row">
          <div class="form-group">
            <label>Freight (USD)</label>
            <input type="text" :value="currentPlantData && currentPlantData.freight_usd" disabled>
          </div>
          <div class="form-group">
            <label>Freight (USD/lb)</label>
            <input type="text" :value="currentPlantData && currentPlantData.freight_usd_lb" disabled>
          </div>
        </div>
      </div>
    </template>

    <div class="tabla-productos">
      <h2>{{ $t('pricing.nuevo_precio.products') }}</h2>
      <table>
        <thead>
          <tr>
            <th>{{ $t('pricing.nuevo_precio.sap') }}</th>
            <th>{{ $t('pricing.nuevo_precio.sku') }}</th>
            <th>{{ $t('pricing.nuevo_precio.planta') }}</th>
            <th>{{ $t('pricing.nuevo_precio.precioKg') }}</th>
            <th>{{ $t('pricing.nuevo_precio.precioUsdCaja') }}</th>
            <th>{{ $t('pricing.nuevo_precio.costoKg') }}</th>
            <th>{{ $t('pricing.nuevo_precio.costoEnvioKg') }}</th>
            <th>{{ $t('pricing.nuevo_precio.costoTotalKg') }}</th>
            <th>{{ $t('pricing.nuevo_precio.profitMin') }}</th>
            <th>{{ $t('pricing.nuevo_precio.profitCalc') }}</th>
            <th>{{ $t('pricing.nuevo_precio.profitCalcUsd') }}</th>
            <th>{{ $t('pricing.nuevo_precio.volumen') }}</th>
            <th v-if="currentPlantData && currentPlantData.invoiceMode === 'EXW + Freight'">{{ $t('pricing.nuevo_precio.CIFPrice') }}</th>
            <th>OK</th>
            <th>{{ $t('pricing.nuevo_precio.eliminar') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(producto, index) in productosAgregados" :key="index">
            <td>{{ producto.sku_id }}</td>
            <td>{{ producto.sku_name }}</td>
            <td>{{ producto.planta_dc }} - {{ producto.planta_name }}</td>
            <td>{{ producto.precio_usd_kg }}</td>
            <td>{{ producto.precio_usd_caja }}</td>
            <td>{{ producto.costo_KG }}</td>
            <td>{{ producto.costo_envio_kg }}</td>
            <td>{{ producto.costo_total_caja }}</td>
            <td>{{ producto.profit_minimo }} %</td>
            <td>{{ producto.profit_calculado_porcentaje }} %</td>
            <td>{{ producto.profit_calculado_usd_kg }}</td>
            <td>{{ producto.volumen }}</td>
            <td v-if="currentPlantData && currentPlantData.invoiceMode === 'EXW + Freight'">{{ producto.CIF_Approx }}</td>
            <td>
              <span :class="producto.ok ? 'text-green' : 'text-red'">
                {{ producto.ok ? '✔️' : '❌' }}
              </span>
            </td>
            <td>
              <button class="delete-row-button" @click="eliminarProducto(index)">
                <img src="@/assets/img/eliminar.png" alt="Eliminar" style="width: 30px; height: auto; margin-right: 5px;" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal simulador -->
    <div v-if="mostrarModal" class="modal-overlay">
      <div class="modal-content">
        <h2>{{ $t('pricing.nuevo_precio.profitCalcUsd') }}</h2>

        <table>
          <thead>
            <tr>
              <th>{{ $t('pricing.nuevo_precio.select') }}</th>
              <th>{{ $t('pricing.nuevo_precio.sap') }}</th>
              <th>{{ $t('pricing.nuevo_precio.sku') }}</th>
              <th>{{ $t('pricing.nuevo_precio.planta') }}</th>
              <th>{{ $t('pricing.nuevo_precio.incoterm') }}</th>
              <th>{{ $t('pricing.nuevo_precio.invoice') }}</th>
              <th>{{ $t('pricing.nuevo_precio.precioKg') }}</th>
              <th>{{ $t('pricing.nuevo_precio.precioUsdCaja') }}</th>
              <th>{{ $t('pricing.nuevo_precio.costoKg') }}</th>
              <th>{{ $t('pricing.nuevo_precio.costoEnvioKg') }}</th>
              <th>{{ $t('pricing.nuevo_precio.costoTotalKg') }}</th>
              <th>{{ $t('pricing.nuevo_precio.profitMin') }}</th>
              <th>{{ $t('pricing.nuevo_precio.profitCalc') }}</th>
              <th>{{ $t('pricing.nuevo_precio.profitCalcUsd') }}</th>
              <th>{{ $t('pricing.nuevo_precio.volumen') }}</th>
              <th v-if="simulacionTieneEXWFlete">{{ $t('pricing.nuevo_precio.CIFPrice') }}</th>
              <th>OK</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="producto in resultadosSimulacion" :key="producto.simulationId">
              <td>
                <input
                    type="radio"
                    :value="producto.simulationId"
                    v-model="skuSeleccionadoModal"
                />
              </td>
              <td>{{ producto.sku_id }}</td>
              <td>{{ producto.sku_name }}</td>
              <td>{{ producto.planta_dc }} - {{ producto.planta_name }}</td>
              <td>{{ producto.incoterm }}</td>
              <td>{{ producto.invoiceMode }}</td>
              <td>{{ producto.precio_usd_kg }}</td>
              <td>{{ producto.precio_usd_caja }}</td>
              <td>{{ producto.costo_KG }}</td>
              <td>{{ producto.costo_envio_kg }}</td>
              <td>{{ producto.costo_total_caja }}</td>
              <td>{{ producto.profit_minimo }} %</td>
              <td>{{ producto.profit_calculado_porcentaje }} %</td>
              <td>{{ producto.profit_calculado_usd_kg }}</td>
              <td>{{ producto.volumen }}</td>
              <td v-if="simulacionTieneEXWFlete">{{ producto.CIF_Approx }}</td>
              <td>
                <span :class="producto.ok ? 'text-green' : 'text-red'">
                  {{ producto.ok ? '✔️' : '❌' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <div
            v-if="showModalError"
            class="alert alert-danger lineas-alert mt-3"
            role="alert"
        >
          {{ modalErrorMessage }}
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" @click="cerrarModal">Cerrar</button>
          <button class="btn verde" :disabled="!skuSeleccionadoModal" @click="agregarProductoDesdeModal">Agregar</button>
        </div>
      </div>
    </div>

    <div class="card">
      <h2>{{ $t('pricing.nuevo_precio.supportFiles') }}</h2>
      <div class="acciones">
        <button class="btn verde">
          <img src="@/assets/img/subir.png" alt="Subir archivo" style="width: 16px; height: 16px; margin-right: 5px;" />
          {{ $t('pricing.nuevo_precio.upFile') }}
          <input
            ref="fileInput"
            type="file"
            class="hidden-file-input"
            @change="handleFileUpload"
            multiple
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.eml,.msg"
          />
        </button>

        <button class="btn rojo" @click="handleDeleteFile">
          <img src="@/assets/img/eliminar.png" alt="Eliminar archivo" style="width: 16px; height: 16px; margin-right: 5px;" />
          {{ $t('pricing.nuevo_precio.delFile') }}
        </button>
      </div>

      <div class="mt-2" v-if="selectedFiles.length">
        <div
          v-for="(file, idx) in selectedFiles"
          :key="idx"
          class="archivo-item"
          style="display: flex; align-items: center; gap: 8px; margin-top: 5px;"
        >
          <input
            type="checkbox"
            :value="file.name"
            v-model="selectedToDelete"
          />
          <small class="text-muted">{{ file.name }}</small>
        </div>
      </div>

      <div v-if="uploadSuccess" class="mt-2 text-success">
        {{ $t('pricing.mis_precios.uploadedOk') }}
      </div>
      <div v-if="deleteSuccess" class="mt-2 text-success">
        {{ $t('pricing.mis_precios.deletedOk') }}
      </div>
      <div v-if="deleteError" class="mt-2 text-danger">
        {{ $t('pricing.nuevo_precio.selectToDelete') || 'Seleccione al menos un archivo para eliminar.' }}
      </div>
    </div>

    <div class="card">
      <h2>{{ $t('pricing.nuevo_precio.comentarios') }}</h2>
      <textarea v-model="comentarios"></textarea>
    </div>

    <div id="successMessage" v-if="showSuccess" class="alert alert-success" role="alert">
      {{ $t('pricing.nuevo_precio.precioCreado') }}
    </div>

    <div id="errorMessage" v-if="showError" class="alert alert-danger" role="alert">
      {{ errorMessage }}
    </div>

    <div v-show="isLoading">
      <div class="spinner"></div>
    </div>

    <div class="acciones finales" v-show="!isLoading">
      <button class="btn verde" @click="enviarRFP">
        <img src="@/assets/img/checked.png" alt="Enviar" style="width: 16px; height: 16px; margin-right: 5px;" />
        {{ $t('pricing.nuevo_precio.enviar') }}
      </button>
      <button class="btn rojo" @click="resetForm">
        <img src="@/assets/img/error.png" alt="Cancelar" style="width: 16px; height: 16px; margin-right: 5px;" />
        {{ $t('pricing.nuevo_precio.cancelar') }}
      </button>
    </div>
  </section>
  </div>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'NuevoPrecioComponent',
  components: { Multiselect },
  data() {
    return {
      /* VIGENCIA */
      fechaInicio: '',
      fechaFin: '',
      fechaMinima: this.obtenerFechaActual(),

      /* CONTEXTO COMERCIAL */
      distribuidor: null,
      email: null,
      selectedSoldTo: null,

      /* MODO DE PRECIO */
      precioMode: 'lb',

      /* SELECCIÓN PRODUCTOS */
      productosAgregados: [],
      agregarErrorMessage: '',
      showAgregarError: false,

      /* RFP: INPUTS DE PRICING */
      lineasProducto: [
        {
          id: 1,
          planta: null,
          skus: [],
          isLoadingSkus: false,
          sku: null,
          precioUsuario: 1,
          volumen: 1
        }
      ],
      nextLineaId: 2,
      lineasErrorMessage: '',
      showLineasError: false,

      /* PLANTA BLOQUEADA DE LA RFP */
      rfpPlanta: null,

      /* CONDICIONES COMERCIALES POR PLANTA */
      plantDataMap: {},

      /* REORDER */
      reorderData: null,
      reorderDataRfp: null,
      distribuidorReorder: null,
      plantaReorder: null,

      /* DATA REMOTA */
      distribuidores: [],
      plants: [],

      /* SIMULADOR */
      resultadosSimulacion: [],
      skuSeleccionadoModal: null,
      mostrarModal: false,
      modalErrorMessage: '',
      showModalError: false,

      /* ARCHIVOS */
      selectedFiles: [],
      selectedToDelete: [],
      uploadSuccess: false,
      deleteSuccess: false,
      deleteError: false,

      /* UI STATE */
      showSuccess: false,
      showError: false,
      errorMessage: '',
      isLoading: false,
      isLoadingPlants: false,
    };
  },
  computed: {
    puedeAgregar() {
      return this.lineasProducto.length === 1 && this.lineaCompleta(this.lineasProducto[0]);
    },
    puedeSimular() {
      return this.lineasProducto.length > 0 && this.lineasProducto.every(linea => this.lineaCompleta(linea));
    },
    currentPlantData() {
      if (!this.rfpPlanta) return null;
      return this.plantDataMap[this.rfpPlanta] || null;
    },
    simulacionTieneEXWFlete() {
      return this.resultadosSimulacion.some(p => p.invoiceMode === 'EXW + Freight');
    }
  },
  watch: {
    distribuidor(nuevo) {
      this.resetDependenciasDistribuidor();
      if (nuevo) this.getPlants(nuevo.ean);
    }
  },
  mounted() {
    const dataReorder = sessionStorage.getItem('reorderData');
    const dataReorderRfp = sessionStorage.getItem('reorderDataRfp');
    if (dataReorder && dataReorderRfp) {
      this.reorderData = JSON.parse(dataReorder);
      this.reorderDataRfp = JSON.parse(dataReorderRfp);
      this.initFormularioDesdeReorden();
    }
    this.getDistribuidores();
  },
  methods: {
    agregarLinea() {
      this.lineasProducto.push({
        id: this.nextLineaId++,
        planta: null,
        skus: [],
        isLoadingSkus: false,
        sku: null,
        precioUsuario: 1,
        volumen: 1
      });
    },
    eliminarLinea(index) {
      if (this.lineasProducto.length === 1) return;
      this.lineasProducto.splice(index, 1);
    },
    lineaCompleta(linea) {
      return !!linea.planta && !!linea.sku && linea.precioUsuario > 0 && linea.volumen > 0;
    },
    validarLinea(linea) {
      if (linea.precioUsuario <= 0) linea.precioUsuario = 1;
      if (linea.volumen <= 0) linea.volumen = 1;
    },
    resetLineasProducto() {
      this.lineasProducto = [
        {
          id: 1,
          planta: null,
          skus: [],
          isLoadingSkus: false,
          sku: null,
          precioUsuario: 1,
          volumen: 1
        }
      ];
      this.nextLineaId = 2;
    },
    customLabelPlanta(option) {
      return `${option.DC} - ${option.plant_name}`;
    },
    resetDependenciasDistribuidor() {
      this.rfpPlanta = null;
      this.plantDataMap = {};
      this.plants = [];
      this.resetLineasProducto();
      this.productosAgregados = [];

      this.lineasErrorMessage = '';
      this.showLineasError = false;
      this.agregarErrorMessage = '';
      this.showAgregarError = false;
      this.modalErrorMessage = '';
      this.showModalError = false;
    },
    initFormularioDesdeReorden() {
      if (!this.reorderDataRfp) return;

      this.distribuidorReorder = this.reorderDataRfp.id_distribuidor;
      this.plantaReorder = this.reorderDataRfp.planta;
      this.rfpPlanta = this.reorderDataRfp.planta;

      this.plantDataMap[this.rfpPlanta] = {
        fleteLb: this.reorderDataRfp.costo_envio_lb || 0,
        fleteKg: this.reorderDataRfp.costo_envio_kg || 0,
        carrier: '',
        incoterm: this.reorderDataRfp.incoterm || '',
        invoiceMode: this.reorderDataRfp.invoice_mode || '',
        delivery: this.reorderDataRfp.delivery || '',
        separate_freight: false,
        freight_usd: '',
        freight_usd_lb: '',
      };

      axios
        .get('/pricing/getPrimaryCarrier', {
          params: {
            sold_to: this.reorderDataRfp.id_distribuidor,
            dc: this.reorderDataRfp.planta,
          },
        })
        .then(response => {
          if (this.plantDataMap[this.rfpPlanta]) {
            this.plantDataMap[this.rfpPlanta].carrier = response.data.carrier;
          }
        })
        .catch(error => {
          console.error('Error obteniendo el carrier:', error);
        });

      if (!this.reorderData || !this.reorderData.length) return;

      const productosConCalculados = this.reorderData.map(producto => {
        return {
          ...producto,
          precio_caja: producto.precio_caja ? Math.round(parseFloat(producto.precio_caja) * 100) / 100 : 0,
          costo_lb: producto.costo_lb ? Math.round(parseFloat(producto.costo_lb) * 100) / 100 : 0,
          costo_envio: producto.costo_envio ? Math.round(parseFloat(producto.costo_envio) * 100) / 100 : 0,
          profit: producto.profit || 0,
          precio_usuario: producto.CIF_Approx - this.reorderDataRfp.costo_envio_lb || 0
        };
      });

      this.productosAgregados = productosConCalculados.map(producto => ({
        sku_id: producto.sku_id,
        sku_name: producto.sku_name,
        planta_dc: this.reorderDataRfp.planta,
        planta_name: '',
        precio_usd_kg: producto.precio_usd_kg,
        precio_usd_caja: producto.precio_usd_caja,
        precio_caja: producto.precio_caja,
        costo_KG: producto.costo_KG,
        costo_lb: producto.costo_lb,
        profit: producto.profit,
        precio_usuario: producto.precio_usuario,
        separate_freight: producto.separate_freight,
        costo_envio_kg: producto.costo_envio,
        costo_envio: producto.costo_envio,
        costo_total_caja: producto.costo_total_caja,
        profit_minimo: producto.profit,
        profit_calculado_porcentaje: producto.profit_calculado_porcentaje,
        profit_calculado_usd_kg: producto.profit_calculado_usd_kg,
        volumen: producto.volumen,
        CIF_Approx: producto.CIF_Approx,
        ok: producto.state_profit === 'true',
      }));
    },
    async getDistribuidores() {
      const rawProfile = sessionStorage.getItem('mccain_service_user_profile');
      const parsedProfile = JSON.parse(rawProfile);
      const dynamicData = JSON.parse(parsedProfile.dynamicData);
      this.email = dynamicData.email;
      try {
        const response = await axios.get('/pricing/getDistribuidores', {
          params: {
            email: this.email
          }
        });
        this.distribuidores = response.data.distribuidores;
      } catch (error) {
        console.error('Error al obtener los distribuidores:', error);
      }
    },
    obtenerFechaActual() {
      const hoy = new Date();
      const yyyy = hoy.getFullYear();
      const mm = String(hoy.getMonth() + 1).padStart(2, '0');
      const dd = String(hoy.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    customLabelDistribuidores(option) {
      return `${option.ean} - ${option.name}`;
    },
    customFilterDistribuidores(option, search) {
      const term = search.toLowerCase();
      return (
        option.name?.toLowerCase().includes(term) ||
        option.ean?.toString().toLowerCase().includes(term)
      );
    },
    customLabelSkus(option) {
      return `${option.id} - ${option.sku}`;
    },
    filterBy(option, _label, search) {
      const searchLower = search.toLowerCase();
      return (
        option.sku.toLowerCase().includes(searchLower) ||
        option.id.toString().includes(searchLower)
      );
    },
    async getPlants(sold_to) {
      try {
        this.isLoadingPlants = true;
        const response = await axios.get('/pricing/getPlants', {
          params: {
            soldTo: sold_to
          }
        });
        this.plants = response.data.plants;
      } catch (error) {
        console.error('Error al obtener las plantas:', error);
      } finally {
        this.isLoadingPlants = false;
      }
    },
    async onSelectPlanta(linea, planta) {
      linea.sku = null;
      linea.skus = [];
      await this.getSkusForLinea(linea, planta.DC);
    },
    onRemovePlanta(linea) {
      linea.sku = null;
      linea.skus = [];
    },
    async getSkusForLinea(linea, plantId) {
      if (!this.distribuidor) return;
      try {
        linea.isLoadingSkus = true;
        const response = await axios.get('/pricing/getSkusPricing', {
          params: {
            soldTo: this.distribuidor.ean,
            plantId: plantId
          }
        });
        const data = response.data.skus;
        if (data?.length) {
          const header = data[0];
          const separate_freight = ['true', '1', 1, true].includes(header.separate_freight);
          const isEXWFlete = header.invoice_mode === 'EXF' && separate_freight;
          const invoiceMode = isEXWFlete ? 'EXW + Freight' : header.invoice_mode;

          this.plantDataMap[plantId] = {
            fleteLb: Math.round(parseFloat(header.costo_envio_lb) * 100) / 100,
            fleteKg: Math.round(parseFloat(header.costo_envio_kg) * 100) / 100,
            carrier: header.primary_carrier,
            delivery: header.delivery,
            incoterm: header.incoterm,
            invoiceMode,
            separate_freight,
            freight_usd: isEXWFlete ? parseFloat(header.freight_usd).toFixed(2) : '',
            freight_usd_lb: isEXWFlete ? parseFloat(header.freight_usd_lb).toFixed(2) : '',
          };

          linea.skus = data.map(sku => ({
            ...sku,
            costo_envio_lb: header.invoice_mode === 'EXW' ? 0 : sku.costo_envio_lb,
            costo_envio_kg: header.invoice_mode === 'EXW' ? 0 : sku.costo_envio_kg,
            costo_envio: header.invoice_mode === 'EXW' ? 0 : sku.costo_envio,
          })).sort((a, b) => a.id - b.id);
        }
      } catch (error) {
        console.error('Error al obtener los SKUs:', error);
      } finally {
        linea.isLoadingSkus = false;
      }
    },
    getPrecioLb(linea) {
      if (this.precioMode === 'lb') return linea.precioUsuario;
      const skuObj = linea.skus.find(s => s.id === linea.sku?.id);
      const net_weight_lb = parseFloat(skuObj?.net_weight_lb) || 1;
      return linea.precioUsuario / net_weight_lb;
    },
    calcularProfitYCIF(precio_usuario, skuObj, invoice_mode, separate_freight) {
      const profit_minimo = parseFloat(skuObj.profit) || 0;
      const net_weight_lb = parseFloat(skuObj.net_weight_lb) || 0;
      const costo_KG = parseFloat(skuObj.costo_KG) || 0;
      const costo_lb = parseFloat(skuObj.costo_lb) || 0;
      const costo_envio_kg = parseFloat(skuObj.costo_envio_kg) || 0;
      const costo_envio_lb = parseFloat(skuObj.costo_envio_lb) || 0;
      const precio_caja = parseFloat(skuObj.precio_caja) || 0;

      const precio_usd_kg = precio_usuario * 2.20462;
      const precio_usd_caja = net_weight_lb * precio_usuario;

      const costo_total_caja = costo_KG + costo_envio_kg;

      const mostrarCIFApprox = invoice_mode === 'EXW + Freight';
      const CIF_Approx = mostrarCIFApprox ? +(precio_usuario + costo_envio_lb).toFixed(2) : null;

      let profit_calculado_usd_kg = 0;
      let profit_calculado_porcentaje = 0;

      if (separate_freight && invoice_mode === 'EXW + Freight') {
        profit_calculado_usd_kg = precio_usd_kg - costo_KG;
        const divisor = precio_usd_kg + costo_envio_kg;
        profit_calculado_porcentaje = divisor > 0 ? (profit_calculado_usd_kg / divisor) * 100 : 0;
      } else if (invoice_mode === 'CIF') {
        profit_calculado_usd_kg = precio_usd_kg - costo_KG - costo_envio_kg;
        profit_calculado_porcentaje = precio_usd_kg > 0 ? (profit_calculado_usd_kg / precio_usd_kg) * 100 : 0;
      } else if (invoice_mode === 'EXW') {
        profit_calculado_usd_kg = precio_usd_kg - costo_KG;
        profit_calculado_porcentaje = precio_usd_kg > 0 ? (profit_calculado_usd_kg / precio_usd_kg) * 100 : 0;
      } else {
        profit_calculado_usd_kg = precio_usd_kg - costo_KG;
        profit_calculado_porcentaje = precio_usd_kg > 0 ? (profit_calculado_usd_kg / precio_usd_kg) * 100 : 0;
      }

      return {
        precio_usd_kg: +precio_usd_kg.toFixed(2),
        precio_usd_caja: +precio_usd_caja.toFixed(2),
        precio_caja: +precio_caja.toFixed(2),
        costo_KG: +costo_KG.toFixed(2),
        costo_lb: +costo_lb.toFixed(2),
        profit: profit_minimo,
        costo_envio_kg: +costo_envio_kg.toFixed(2),
        costo_envio: +costo_envio_kg.toFixed(2),
        costo_total_caja: +costo_total_caja.toFixed(2),
        profit_minimo,
        profit_calculado_porcentaje: +profit_calculado_porcentaje.toFixed(2),
        profit_calculado_usd_kg: +profit_calculado_usd_kg.toFixed(2),
        CIF_Approx: CIF_Approx !== null ? +CIF_Approx.toFixed(2) : null
      };
    },
    addToCart() {
      this.showLineasError = false;
      this.lineasErrorMessage = '';
      this.showAgregarError = false;
      this.agregarErrorMessage = '';

      if (this.lineasProducto.length !== 1) return;

      const linea = this.lineasProducto[0];
      if (!this.lineaCompleta(linea)) return;

      this.validarLinea(linea);

      const selectedSkuObj = linea.skus.find(sku => sku.id === linea.sku.id);
      if (!selectedSkuObj) return;

      const plantData = this.plantDataMap[linea.planta.DC];
      if (!plantData) return;

      if (this.rfpPlanta && linea.planta.DC !== this.rfpPlanta) {
        this.mostrarErrorSkuAgregados(this.$t('pricing.nuevo_precio.condicion_planta'));
        return;
      }

      const resultado = this.calcularProfitYCIF(
          this.getPrecioLb(linea),
          selectedSkuObj,
          plantData.invoiceMode,
          plantData.separate_freight
      );

      const nuevoProducto = {
        sku_id: selectedSkuObj.id,
        sku_name: selectedSkuObj.sku,
        planta_dc: linea.planta.DC,
        planta_name: linea.planta.plant_name,
        ...resultado,
        precio_usuario: this.getPrecioLb(linea),
        separate_freight: plantData.separate_freight,
        volumen: linea.volumen,
        ok: parseFloat(resultado.profit_calculado_porcentaje) >= resultado.profit_minimo,
      };

      if (this.existeSkuEnAgregados(nuevoProducto)) {
        this.mostrarErrorSkuAgregados(this.$t('pricing.nuevo_precio.condicion_sku'));
        return;
      }

      this.productosAgregados.push(nuevoProducto);
      if (!this.rfpPlanta) {
        this.rfpPlanta = linea.planta.DC;
      }
      this.resetLineasProducto();
      this.showAgregarError = false;
      this.agregarErrorMessage = '';
    },
    simular() {
      this.showModalError = false;
      this.modalErrorMessage = '';
      this.showLineasError = false;
      this.lineasErrorMessage = '';
      this.showAgregarError = false;
      this.agregarErrorMessage = '';

      if (!this.lineasProducto.length) return;

      if (this.existeEscenarioDuplicadoEnLineas()) {
        this.mostrarErrorLineas(this.$t('pricing.nuevo_precio.condicion_simular'));
        return;
      }

      this.resultadosSimulacion = [];
      this.skuSeleccionadoModal = null;

      this.lineasProducto.forEach(linea => {
        if (!this.lineaCompleta(linea)) return;

        this.validarLinea(linea);

        const selectedSkuObj = linea.skus.find(sku => sku.id === linea.sku.id);
        if (!selectedSkuObj) return;

        const resultado = this.calcularProducto(selectedSkuObj, linea);
        if (resultado) {
          this.resultadosSimulacion.push(resultado);
        }
      });

      if (this.resultadosSimulacion.length) {
        this.mostrarModal = true;
      }
    },
    cerrarModal() {
      this.mostrarModal = false;
      this.modalErrorMessage = '';
      this.showModalError = false;
      this.resultadosSimulacion = [];
      this.skuSeleccionadoModal = null;
    },
    agregarProductoDesdeModal() {
      this.showModalError = false;
      this.modalErrorMessage = '';
      this.showAgregarError = false;
      this.agregarErrorMessage = '';

      if (!this.skuSeleccionadoModal) return;

      const producto = this.resultadosSimulacion.find(
          p => p.simulationId === this.skuSeleccionadoModal
      );

      if (!producto) return;

      if (this.rfpPlanta && producto.planta_dc !== this.rfpPlanta) {
        this.mostrarErrorModal(this.$t('pricing.nuevo_precio.condicion_planta'));
        return;
      }

      if (this.existeSkuEnAgregados(producto)) {
        this.mostrarErrorModal(this.$t('pricing.nuevo_precio.condicion_sku'));
        return;
      }

      const product = { ...producto };
      delete product.simulationId;

      this.productosAgregados.push(product);
      if (!this.rfpPlanta) {
        this.rfpPlanta = producto.planta_dc;
      }

      this.cerrarModal();
      this.resetLineasProducto();
    },
    calcularProducto(selectedSkuObj, linea) {
      if (!selectedSkuObj || !linea) return null;

      const plantData = this.plantDataMap[linea.planta?.DC] || {};

      const resultado = this.calcularProfitYCIF(
          this.getPrecioLb(linea),
          selectedSkuObj,
          plantData.invoiceMode,
          plantData.separate_freight
      );

      return {
        simulationId: linea.id,
        sku_id: selectedSkuObj.id,
        sku_name: selectedSkuObj.sku,
        planta_dc: linea.planta?.DC,
        planta_name: linea.planta?.plant_name,
        incoterm: plantData.incoterm,
        invoiceMode: plantData.invoiceMode,
        ...resultado,
        precio_usuario: this.getPrecioLb(linea),
        separate_freight: plantData.separate_freight,
        volumen: linea.volumen,
        ok: parseFloat(resultado.profit_calculado_porcentaje) >= resultado.profit_minimo,
      };
    },
    eliminarProducto(index) {
      this.productosAgregados.splice(index, 1);
      if (this.productosAgregados.length === 0) {
        this.rfpPlanta = null;
      }
    },
  handleFileUpload(event) {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    files.forEach(file => {
      if (!this.selectedFiles.find(f => f.name === file.name)) {
        this.selectedFiles.push(file);
      }
    });

    this.uploadSuccess = true;
    setTimeout(() => {
      this.uploadSuccess = false;
    }, 2000);
  },
  handleDeleteFile() {
    if (!this.selectedToDelete.length) {
      this.deleteError = true;
      setTimeout(() => {
        this.deleteError = false;
      }, 2000);
      return;
    }

    this.selectedFiles = this.selectedFiles.filter(
      file => !this.selectedToDelete.includes(file.name)
    );
    this.selectedToDelete = [];
    this.deleteSuccess = true;

    setTimeout(() => {
      this.deleteSuccess = false;
    }, 2000);
  },
  async enviarRFP() {
    if (!this.fechaInicio || !this.fechaFin) {
      this.errorMessage = this.$t('pricing.nuevo_precio.fechaVacia');
      this.showError = true;
      this.showSuccess = false;
      setTimeout(() => {
        this.showError = false;
      }, 4000);
      return;
    }

    if (!this.productosAgregados || this.productosAgregados.length === 0) {
      this.errorMessage = this.$t('pricing.nuevo_precio.precioVacio');
      this.showError = true;
      this.showSuccess = false;
      setTimeout(() => {
        this.showError = false;
      }, 4000);
      return;
    }

    if (!this.comentarios || this.comentarios === '') {
      this.errorMessage = this.$t('pricing.nuevo_precio.comentariosVacios');
      this.showError = true;
      this.showSuccess = false;
      setTimeout(() => {
        this.showError = false;
      }, 4000);
      return;
    }

    try {
      this.isLoading = true;
      const formData = new FormData();
      const rawProfile = sessionStorage.getItem('mccain_service_user_profile');
      const parsedProfile = JSON.parse(rawProfile);
      const firstname = parsedProfile.firstname;
      const email = parsedProfile.email;

      formData.append('firstname', firstname);
      formData.append('email', email);

      const productosPrecios = this.productosAgregados.map(producto => {
        const product = { ...producto };
        delete product.simulationId;

        return {
          ...product,
          state_profit: product.ok
        };
      });

      formData.append('pricingItems', JSON.stringify(productosPrecios));

      if (this.selectedFiles && this.selectedFiles.length) {
        for (let i = 0; i < this.selectedFiles.length; i++) {
          formData.append('files[]', this.selectedFiles[i]);
        }
      }

      const plantData = this.currentPlantData || {};
      const rfpItem = {
        comentario: this.comentarios,
        costo_envio_kg: plantData.fleteKg || null,
        costo_envio_lb: plantData.fleteLb || null,
        delivery: plantData.delivery || '',
        end_date: this.fechaFin,
        start_date: this.fechaInicio,
        id_distribuidor: this.distribuidor?.ean || this.distribuidorReorder,
        incoterm: plantData.incoterm || '',
        invoice_mode: plantData.invoiceMode || '',
        planta: this.rfpPlanta || this.plantaReorder,
      };

      formData.append('rfp[]', JSON.stringify(rfpItem));

      const response = await axios.post('pricing/sendPricingItems', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      this.isLoading = false;

      // The API can answer 200 with error:true when the RFP could not be created.
      // Without this check the vendor sees "sent successfully" over an empty RFP.
      if (!response.data || response.data.error !== false) {
        this.showSuccess = false;
        this.errorMessage = (response.data && response.data.message)
          || this.$t('pricing.nuevo_precio.precioError');
        this.showError = true;
        return;
      }

      this.showSuccess = true;
      this.showError = false;
      // Only clear the form once the RFP is known to exist
      this.resetForm();
    }
    catch (error) {
      this.isLoading = false;
      console.error('Error al enviar RFP:', error);
      this.showSuccess = false;
      this.errorMessage = this.getSubmitErrorMessage(error);
      this.showError = true;
    }
  },
  getSubmitErrorMessage(error) {
    const data = error.response && error.response.data;

    // 422: the payload does not match the contract declared in SendPricingItemsRequest
    if (error.response && error.response.status === 422 && data && data.errors) {
      return [].concat(...Object.values(data.errors)).join(' ');
    }

    return (data && data.message) || this.$t('pricing.nuevo_precio.precioError');
  },
  resetForm() {
    sessionStorage.removeItem('reorderData');
    sessionStorage.removeItem('reorderDataRfp');
    this.fechaInicio = '';
    this.fechaFin = '';
    this.productosAgregados = [];
    this.comentarios = '';
    this.distribuidor = null;
    this.plants = [];
    this.rfpPlanta = null;
    this.plantDataMap = {};
    this.precioMode = 'lb';
    this.resetLineasProducto();
    this.resultadosSimulacion = [];
    this.skuSeleccionadoModal = null;
    this.selectedFiles = [];
    this.selectedToDelete = [];
    this.uploadSuccess = false;
    this.deleteSuccess = false;
    this.deleteError = false;
    this.errorMessage = '';
    this.showError = false;
    this.lineasErrorMessage = '';
    this.showLineasError = false;
    this.agregarErrorMessage = '';
    this.showAgregarError = false;
    this.modalErrorMessage = '';
    this.showModalError = false;
    setTimeout(() => {
      this.showSuccess = false;
    }, 4000);
  },
  abrirCalendario() {
    const input = this.$refs.inputFechaInicio;
    if (input.showPicker) {
      input.showPicker();
    } else {
      input.click();
    }
  },
  abrirCalendarioFin() {
    const input = this.$refs.inputFechaFin;
    if (input?.showPicker) {
      input.showPicker();
    } else {
      input.click();
    }
  },
    esMismoSkuAgregado(a, b) {
      return a?.sku_id === b?.sku_id;
    },
    existeSkuEnAgregados(producto) {
      return this.productosAgregados.some(item =>
          this.esMismoSkuAgregado(item, producto)
      );
    },
    existeEscenarioDuplicadoEnLineas() {
      const escenarios = this.lineasProducto
          .filter(linea => this.lineaCompleta(linea))
          .map(linea => `${linea.planta?.DC}-${linea.sku.id}-${Number(linea.precioUsuario)}-${Number(linea.volumen)}`);

      return new Set(escenarios).size !== escenarios.length;
    },
    mostrarErrorSkuAgregados(mensaje, tiempo = 3000) {
      this.agregarErrorMessage = mensaje;
      this.showAgregarError = true;
      this.showSuccess = false;

      setTimeout(() => {
        this.showAgregarError = false;
        this.agregarErrorMessage = '';
      }, tiempo);
    },
    mostrarErrorLineas(mensaje, tiempo = 3000) {
      this.lineasErrorMessage = mensaje;
      this.showLineasError = true;

      setTimeout(() => {
        this.showLineasError = false;
        this.lineasErrorMessage = '';
      }, tiempo);
    },
    mostrarErrorModal(mensaje, tiempo = 3000) {
      this.modalErrorMessage = mensaje;
      this.showModalError = true;

      setTimeout(() => {
        this.showModalError = false;
        this.modalErrorMessage = '';
      }, tiempo);
    },
  }
}
</script>

<style scoped>
/* =========================
   CONTENEDOR GENERAL
========================= */
.nuevo-precio-container {
  width: 90%;
  margin: auto;
  padding: 2rem;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
}

.title-with-back {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 30px;
}

.back-arrow {
  text-decoration: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
}

.back-arrow:hover {
  color: #000;
}

/* =========================
   TARJETAS GENERALES
========================= */
.card {
  background-color: #f9f9f9;
  border: 1px solid #e0e0e0;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.subtitulo {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: #34495e;
}

/* =========================
   FORMULARIOS GENERALES
========================= */
.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.form-group {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 0.4rem;
  font-weight: 600;
  color: #555;
}

input,
select,
textarea {
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.3s ease;
}

input:focus,
select:focus,
textarea:focus {
  border-color: #3498db;
}

textarea {
  resize: vertical;
  min-height: 120px;
}

/* =========================
   MODO DE PRECIO
========================= */
.precio-mode-group {
  margin-bottom: 1.5rem;
}

.precio-mode-toggle {
  display: flex;
  gap: 1.5rem;
  align-items: center;
  padding: 0.4rem 0;
}

.precio-mode-toggle label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-weight: normal;
  margin-bottom: 0;
}

.precio-mode-toggle input[type="radio"] {
  padding: 0;
  border: none;
  width: auto;
}

/* =========================
   BLOQUES DE PRODUCTO
========================= */
.producto-card {
  background: #fafafa;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.producto-card-header {
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #5c6b73;
}

.producto-form {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-end;
  margin-bottom: 0;
}

.planta-select {
  flex: 2 1 320px;
}

.producto-select {
  flex: 2 1 320px;
}

.precio-input,
.volumen-input {
  flex: 1 1 180px;
}

.volumen-acciones {
  display: flex;
  align-items: center;
  gap: 8px;
}

.volumen-field {
  flex: 1;
  min-width: 0;
}

.btn-icon {
  border: none;
  background: #3498db;
  color: white;
  width: 34px;
  height: 34px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.btn-delete {
  background: #e74c3c;
}

.lineas-alert {
  margin-top: -0.5rem;
  margin-bottom: 1rem;
}
/* =========================
   ACCIONES / BOTONES
========================= */
.acciones {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 2rem;
}

.acciones.finales {
  justify-content: center;
  margin-top: 2rem;
}

.acciones small {
  flex-basis: 100%;
  margin-top: 4px;
  font-size: 12px;
  color: #6c757d;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  color: white;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.btn:hover {
  transform: scale(1.03);
}

.btn.verde {
  background-color: #28a745;
}

.btn.celeste {
  background-color: #3498db;
}

.btn.rojo {
  background-color: #dc3545;
}

/* =========================
   TABLA DE PRODUCTOS
========================= */
.tabla-productos table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 0.95rem;
}

.tabla-productos th {
  background-color: #f0f0f0;
  color: #2c3e50;
  font-weight: bold;
  padding: 0.75rem;
}

.tabla-productos td {
  border: 1px solid #ddd;
  padding: 0.6rem;
  text-align: center;
}

.delete-row-button {
  cursor: pointer;
  border: none;
  background-color: white;
}

/* =========================
   MODAL
========================= */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
}

.modal-footer {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

/* =========================
   ARCHIVOS
========================= */
.hidden-file-input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

/* =========================
   RESPONSIVE
========================= */
@media (max-width: 768px) {
  .producto-card {
    padding: 12px;
  }

  .producto-form {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .planta-select,
  .producto-select,
  .precio-input,
  .volumen-input {
    width: 100%;
    flex: 1 1 100%;
  }

  .volumen-acciones {
    width: 100%;
  }

  .volumen-field {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .btn {
    flex: 1 1 100%;
  }
}
</style>